// Corpo de um artigo renderizado com o Markdown seguro. Reusado pelo painel do Nexo e pela Central.
// Imagens resolvem pela URL com gate (helpImageUrl); links internos navegam pela SPA; links "artigo:slug"
// abrem outro artigo pelo mesmo mecanismo.
import { helpImageUrl, type HelpArticleDetail } from "@/lib/helpApi";
import { HelpMarkdown } from "@/lib/helpMarkdown";

/**
 * Remove um título H1 no INÍCIO do conteúdo — o cabeçalho do artigo já exibe o título, então um "# Título"
 * logo na primeira linha apareceria duplicado. Só o primeiro H1 inicial é removido; demais headings ficam.
 */
function stripLeadingH1(markdown: string): string {
  const lines = (markdown ?? "").replace(/\r\n/g, "\n").split("\n");
  let i = 0;
  while (i < lines.length && lines[i].trim() === "") i++;
  if (i < lines.length && /^#\s+/.test(lines[i].trim())) {
    lines.splice(0, i + 1);
    while (lines.length && lines[0].trim() === "") lines.shift();
    return lines.join("\n");
  }
  return markdown;
}

export function HelpArticleBody({
  article,
  onNavigate,
  onOpenArticle,
}: {
  article: HelpArticleDetail;
  onNavigate?: (path: string) => void;
  onOpenArticle?: (slug: string) => void;
}) {
  return (
    <article className="space-y-2">
      <header className="space-y-1">
        <h2 className="text-lg font-semibold leading-tight">{article.title}</h2>
        {article.summary ? <p className="text-sm text-muted-foreground">{article.summary}</p> : null}
      </header>
      <HelpMarkdown
        content={stripLeadingH1(article.contentMarkdown)}
        handlers={{
          resolveImageUrl: (imageId) => helpImageUrl(article.id, imageId),
          onNavigate,
          onOpenArticle,
        }}
      />
      {article.lastReviewedAt ? (
        <footer className="mt-4 border-t border-border pt-2 text-xs text-muted-foreground">
          Última revisão: {new Date(article.lastReviewedAt).toLocaleDateString("pt-BR")}
          {article.lastReviewedBy ? ` · ${article.lastReviewedBy}` : ""}
        </footer>
      ) : null}
    </article>
  );
}
